<template>
  <div class="home">
    <!-- <div class="video">
      <div class="mobile">
        <img src="../assets/mobile-home-header.png" />
        <a
          target="_blank"
          class="mobile-home-watch-video-btn"
          href="https://www.youtube.com/watch?v=-gaKJn43uCI"
        >
          <img src="../assets/mobile-home-watch-video-btn.svg" />
        </a>
      </div>
      <iframe
        width="100%"
        height="675"
        src="https://www.youtube.com/embed/-gaKJn43uCI"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div> -->

    <template v-if="banners.length > 0">
      <Swiper :data="banners">
        <template slot-scope="{ slide }">
          <a :href="slide.url" target="_blank">
            <img :src="slide.image" style="width: 100%;" />
          </a>
        </template>
      </Swiper>
    </template>
    <template v-else>
      <div style="margin-bottom: 30px;"></div>
    </template>
    <div class="mobile call">
      <a href="tel:04-2389-2887">
        <img src="../assets/mobile-home-call-btn.svg" />
      </a>
      <p>南屯校 04-2389-2887</p>
    </div>
    <home-vision />
    <div class="label year">113年</div>
    <Divider class="divider" />
    <div class="row honor">
      <CircleItem
        class="admitted-number"
        label="申請上衛/曉/明國中"
        :number="350"
        unit="人"
      />
      <CircleItem
        class="admitted-number"
        label="會考5A以上"
        :number="194"
        unit="人"
      />
      <CircleItem
        class="admitted-number"
        label="會考達一女中標準"
        :number="157"
        unit="人"
      />
      <CircleItem
        class="admitted-number"
        label="錄取台中一中科學班"
        :number="15"
        unit="人"
      />
    </div>
    <div class="row circles">
      <CircleItem class="circle" label="創立" :number="32" unit="年" />
      <CircleItem class="circle" label="直營校區" :number="5" unit="校" />
      <CircleItem class="circle" label="加盟校區" :number="11" unit="校" />
      <CircleItem class="circle" label="達人數理品牌" :number="2" unit="校" />
    </div>
    <NewsContainer />
  </div>
</template>

<script>
import CircleItem from "@/components/CircleItem.vue";
import Divider from "@/components/Divider.vue";
import NewsContainer from "@/components/NewsContainer.vue";
import HomeVision from "../components/HomeVision.vue";
import { withApiClient } from "@/api/ApiClient.js";
import Swiper from "@/components/Swiper.vue";

const BannerContainer = {
  name: "home",
  components: {
    CircleItem,
    Divider,
    NewsContainer,
    HomeVision,
    Swiper
  },
  data: function() {
    return {
      banners: []
    };
  },
  mounted() {
    this.handleBanners();
  },
  methods: {
    handleBanners() {
      this.apiClient.fetchBanners().subscribe(resp => {
        this.banners = resp.list;
      });
    }
  }
};
export default withApiClient(BannerContainer);
</script>

<style lang="scss" scoped>
iframe {
  border-bottom: 12px solid #63abcd;
  margin-bottom: 42px;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: center;

  &.circles {
    max-width: 1024px;
    margin: 0 auto 44px;
    justify-content: space-around;
  }

  .circle {
    &:nth-child(even) {
      background-color: #b7e0f3;
    }
    &:nth-child(odd) {
      background-color: #f3f7ca;
    }
  }

  .admitted-number {
    margin: 0 6px;
    width: 120px !important;
    @media (min-width: 1023px) {
      width: 190px !important;
    }
  }
}

.label {
  background-color: #c4cb7a;
  border-radius: 10px;
  color: white;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  box-sizing: border-box;
}

.year {
  padding: 3px 16px;
  margin: auto;
  width: 88px;
  margin-top: 20px;
  margin-bottom: 19px;
}

.divider {
  max-width: 863px;
  margin: auto;
}

@media (max-width: 1023px) {
  .video {
    .mobile {
      position: relative;
      > img {
        width: 100%;
      }

      > a {
        position: absolute;
        bottom: 27px;
        left: calc(50% - 55.5px);
      }
    }

    iframe {
      display: none;
    }
  }

  .call {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #1c2e53;
    margin: 13px auto;

    img {
      width: 155px;
    }
  }

  .circles {
    margin-bottom: 25px !important;
    justify-content: center !important;
    gap: 36px;
  }

  .divider {
    margin: auto 10px;
  }

  .honor {
    display: grid;
    grid-template-areas:
      ". ."
      ". .";
  }

  .mobile-home-watch-video-btn {
    width: 110px;
  }
}

@media (max-width: 460px) {
  .circles {
    display: grid;
    grid-template-columns: repeat(2, auto);
    row-gap: 20px;
    column-gap: 70px;
    justify-items: center;
  }
}
</style>
